var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mdn-Heading mdn-Heading--sm mb-5"},[_vm._v("Criar Ticket Instalação")]),_c('FormularioTicketInstalacaoComponent',{attrs:{"tipoFormulario":_vm.tipoFormulario,"ticket":_vm.ticket}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }